import React, {useState, useEffect} from 'react';
import { useWindowSize } from '../Utility/hooks';

import styled from 'styled-components';
import {AppearFromBottom} from '../../../global/style';

const StyledIframe = styled.iframe`
  position: relative;
  margin-bottom: 10px; 
  width: 100%;
  border-radius:15px;

`;

const Loading = styled.img`
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 99;
  top: 50%;
  transform: translateY(-50%);
  @media screen and (max-width: ${(props) => props.theme.screenSizes.breakXsmall}) {
    width: 50%;
  }
  @media screen and (max-width: ${(props) => props.theme.screenSizes.breakSmall}) {
    width: 50%;
  }
`;

function Iframe({data}) {
  const [loading, setLoading] = useState(true);
  const { width, height } = useWindowSize();

  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if(data.orientation === 'portrait') {
      if (width > 1000) {
        if (height >= 900) {
          setMaxHeight(height - 470);
        } else if (height >= 500 && height < 900) {
          setMaxHeight(height - 350);
        } else if (height < 500 && height >= 450) {
          setMaxHeight(height - 230);
        } else if (height < 450) {
          setMaxHeight(height);
        }
      } else if(width < 360){
        setMaxHeight(height-270);
      } else {
        setMaxHeight(height-210);
      }
    } else {
      setMaxHeight(470);

      if(width < 320) {
        setMaxHeight(150);
      }
      else if(width < 500) {
        setMaxHeight(215);
      }
      else if(width < 720) {
        setMaxHeight(324);
      }
      else if(width < 1024) {
        setMaxHeight(538);
      }
      else if(width < 1800) {
        setMaxHeight(356);
      }
      else if(width >= 1800) {
        setMaxHeight(470);
      }
    }

  }, [height, width]);

  return (
    <AppearFromBottom>
      {loading && <Loading alt="loading search" src={window.location.origin + '/images/loading-search.gif'} />}
      <StyledIframe title="google-map" onLoad={() => setLoading(false)} height={maxHeight} src={data.url} frameBorder="0"  scrolling="no" />
    </AppearFromBottom>
  )
}

export default Iframe;
